import {useBoolState} from "../../hooks";
import {Fragment} from "react";
import {defineMessage} from "react-intl";
import FormattedButton from "../FormattedButton";
import SaveDialog from "./SaveDeviceVariantDialog";

type CreateButtonProps = {
    onSuccess: () => void;
};

export default ({onSuccess}: CreateButtonProps) => {
    const [isOpen, open, close] = useBoolState();

    return (
        <Fragment>
            <FormattedButton
                onClick={open}
                message={defineMessage({id: "device_variant.create", defaultMessage: "New device variant"})}
            />
            <SaveDialog isOpen={isOpen} close={close} onSuccess={onSuccess} />
        </Fragment>
    );
};
